import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControl,
    Typography,
    Box,
    styled
} from '@mui/material';
import color from 'src/theme/color';

export const StyledDialog = styled(Dialog)`
    & .MuiPaper-root {
        background-color: ${color.darkGray};
        border-radius: 12px;
        min-width: 420px;
        padding: 8px;
    }
`;

export const ModalTitle = styled(DialogTitle)`
    font:
        600 18px/22px 'Inter',
        sans-serif;
    color: ${color.white90};
`;

export const ModalContent = styled(DialogContent)`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding-top: 16px !important;
`;

export const ModalActions = styled(DialogActions)`
    padding: 16px 24px;
    gap: 12px;
`;

export const FieldRow = styled(Box)`
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const FieldLabel = styled(Typography)`
    font:
        500 14px/17px 'Inter',
        sans-serif;
    color: ${color.white90};
    min-width: 60px;
    flex-shrink: 0;
`;

export const StatusFormControl = styled(FormControl)`
    width: 130px;
`;

// The shared Switch's "Off"/"On" labels use an unitless line-height of 15
// with a 12px font (SwitchInputSX/SwitchInputSwitchedSX), which computes to a
// 180px line-height and blows the row height up to ~180px. We also strip the
// 10px margin the MUI switch gets from getSwitchStyleTheme. Both are scoped
// here so the toggle row is as tight as the dropdown rows.
export const SwitchWrap = styled(Box)`
    display: flex;
    align-items: center;

    & > * {
        margin: 0 !important;
    }

    & .MuiSwitch-root {
        margin: 0 !important;
    }

    & .MuiTypography-root {
        line-height: normal !important;
    }
`;
